var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_vm._v("提示：该应用只支持手机端！")])}
var staticRenderFns = []

export { render, staticRenderFns }